import { Fetch } from "./util/InterceptedFetch";
import { BuildUri } from "./util/BuildUri";

import { HorseRequest } from "../requests/HorseRequests";
import { MultiPatchRequest } from "../requests/PatchRequests";

import { ListWrapper } from "../model/ListWrapper";
import { SimpleHorse, Horse } from "../model/Horse";

export interface HorseFilterParameters {
    name?: string;
    gaitId?: number;
    fullTextSearch?: string;
}

export class HorsesEndpoints {
    constructor(private fetch: Fetch) {}

    getHorseList(
        limit: number = 10,
        startAt: number = 0,
        orderBy: string | undefined = undefined,
        filters: HorseFilterParameters = {}
    ): Promise<ListWrapper<SimpleHorse>> {
        return this.fetch(BuildUri("/horse", {}, { limit, startAt, orderBy, ...filters }));
    }

    getHorse(HorseId: number): Promise<Horse> {
        return this.fetch(BuildUri("/horse/{HorseId}", { HorseId }));
    }

    createHorse(request: HorseRequest): Promise<Horse> {
        return this.fetch(BuildUri("/horse"), { method: "POST", body: request });
    }

    editHorse(HorseId: number, patchRequests: MultiPatchRequest): Promise<Horse> {
        return this.fetch(BuildUri("/horse/{HorseId}", { HorseId }), { method: "PATCH", body: patchRequests });
    }

    deleteHorse(HorseId: number): Promise<void> {
        return this.fetch(BuildUri("/horse/{HorseId}", { HorseId }), { method: "DELETE" });
    }
}



// WEBPACK FOOTER //
// ./src/endpoints/HorseEndpoints.ts